import { Navigate, Route, Routes as ReactRouterRoutes } from 'react-router-dom';

import { getEnvRequired } from '../utilities/env';
import { AppointmentConfigPage } from '../../pages/Appointment/AppointmentConfigPage';
import { AppointmentListPage } from '../../pages/Appointment/AppointmentListPage';
import { GoogleOAuthCallbackPage } from '../../pages/Appointment/GoogleOAuthCallbackPage';
import { DossierPage } from '../../pages/Dossier/Dossier';
import { FiltersPanelLayout } from '../../pages/Filters/FiltersPanelLayout';
import { HomepageRoute } from '../../pages/Homepage/HomepageRoute';
import { MessageTemplateRoutes } from '../../pages/MessageTemplate/Route';
import { PipelineRoutes } from '../../pages/Pipeline/Route';
import { TodoRoutes } from '../../pages/Todo/Route';
import { AppointmentLayout } from '../../pages/Appointment/AppointmentLayout';
/* AB ab_flex_offer — sunsets 2026-10-31, delete this import + its usage below */
import { AB_FlexOfferSuiviRoute } from '../../pages/AB_FlexOfferSuivi';
import { AB_FLEX_OFFER_SUIVI_PATH } from '../../pages/AB_FlexOfferSuivi/AB_useFlexOfferEligible';

import { NotFoundRedirect } from './NotFoundRedirect';

/* BEGIN - transient appointment-config-page - PR #TODO_AFTER_PR_CREATION_appointment-config-page */
import { TransientAppointmentPage } from '@transient/appointment-config-page';
/* END - transient appointment-config-page - PR #TODO_AFTER_PR_CREATION_appointment-config-page */

export const RM_BASENAME = getEnvRequired('RM_APP_BASENAME');
export const DEFAULT_VIEW_ROUTE = '/homepage';

export const RequestManagerRoutes = (): JSX.Element => (
    <ReactRouterRoutes>
        <Route element={<FiltersPanelLayout />}>
            <Route path="/homepage/*" element={<HomepageRoute />} />
            <Route path="/process/*" element={<PipelineRoutes />} />
            <Route path="/todo/*" element={<TodoRoutes />} />
        </Route>
        <Route path="/templates/*" element={<MessageTemplateRoutes />} />
        {/* BEGIN - transient appointment-config-page - PR #TODO_AFTER_PR_CREATION_appointment-config-page */}
        <Route path="/appointment" element={<TransientAppointmentPage />} />
        {/* END - transient appointment-config-page - PR #TODO_AFTER_PR_CREATION_appointment-config-page */}
        <Route path="/appointment/bis" element={<AppointmentLayout />}>
            <Route index element={<Navigate to="config" replace />} />
            <Route path="config" element={<AppointmentConfigPage />} />
            <Route path="list" element={<AppointmentListPage />} />
        </Route>
        <Route path="/calendar/callback" element={<GoogleOAuthCallbackPage />} />
        {/* AB ab_flex_offer — sunsets 2026-10-31 */}
        <Route path={AB_FLEX_OFFER_SUIVI_PATH} element={<AB_FlexOfferSuiviRoute />} />
        <Route path="/dossier/:dossierId/*" element={<DossierPage />} />
        <Route path="*" element={<NotFoundRedirect to={DEFAULT_VIEW_ROUTE} />} />
    </ReactRouterRoutes>
);
